module.exports = __webpack_public_path__ + "static/media/belfast.c1bcb174.png";